export default "__VITE_ASSET__BN0fWI38__"